import React from "react";

import Svg, { Path } from "components/Svg";

const Hexagon = props => (
	<Svg width="174" height="200" viewbox="0 0 174 200">
		<Path
			fill={props.fill || "black"}
			fillOpacity={props.opacity || "0.30"}
			d="M69.28203230275508 9.999999999999998Q86.60254037844386 0 103.92304845413264 9.999999999999998L155.88457268119896 40Q173.20508075688772 50 173.20508075688772 70L173.20508075688772 130Q173.20508075688772 150 155.88457268119896 160L103.92304845413264 190Q86.60254037844386 200 69.28203230275508 190L17.320508075688775 160Q0 150 0 130L0 70Q0 50 17.320508075688775 40Z"
		/>
	</Svg>
);

export default Hexagon;



// WEBPACK FOOTER //
// ./src/components/svgs/Hexagon/index.js